import { ToWords } from 'to-words';

// Configuration for to Words
export const toWords = new ToWords({
  localeCode: 'en-IN',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      name: 'Rupee',
      plural: 'Rupees',
      symbol: '₹',
      fractionalUnit: {
        name: 'Paisa',
        plural: 'Paise',
        symbol: '',
      },
    },
  },
});

export const toWordsUSD = new ToWords({
  localeCode: 'en-US',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      name: 'dollar',
      plural: 'dollars',
      symbol: '$',
      fractionalUnit: {
        name: 'cent',
        plural: 'cents',
        symbol: '¢',
      },
    },
  },
});

const NRS = 'Nrs.';
const Dollar = '$';

export const CURRENCY_OPTIONS = [
  { value: '', label: 'None' },
  { value: NRS, label: 'Nepalese Rupee (Nrs.)' },
  { value: Dollar, label: 'US Dollar ($)' },
];

export const TO_WORDS_BY_CURRENCY = {
  [NRS]: toWords,
  [Dollar]: toWordsUSD,
};
